<template lang="pug">
.v-map-google.map-google
	.map-google__map(id='map')
	button.field-map__zoom-button(v-if="!type" type="button" @click="openModal")
		v-svg-icon.field-map__zoom-button--icon(icon="open-full")
	.map-google__aside(v-if="computedItems.length !== filtredItemsLenght || asideVisible " :class="{'open' : isAsideOpen}")
		.map-google__aside-head
			.map-google__aside-info(v-if="variables" @click="openAside") {{ `${variables?.found} ${computedItems.length} ${variables?.object}` }}
			button.map-google__aside-toggle(@click="openAside")
				v-svg-icon.map-google__aside-toggle-icon(:icon="isAsideOpen ? 'toggle-left' : 'toggle-right'")
		.map-google__aside-body.scrollbar
			v-product-list(template="map-list" :items="computedItems")
	.map-google__drawing(v-if="type" )
		button.map-google__drawing-button(@click="drawing")
			v-svg-icon.map-google__drawing-button-icon(:icon="handleDrawing ? 'close-sm' : 'drawing'")
</template>
<script>
import { Loader } from "@googlemaps/js-api-loader"
import { MarkerClusterer } from "@googlemaps/markerclusterer";
import throttle from "../scripts/helpers/throttle.js";
import formattingMixin from '../components/mixins/v-mixin-formatting.vue';
import isMobMixin from '../components/mixins/v-mixin-is-mob.vue';
import controller from "../scripts/controller/controller.js";
import fitMapCircleWithContext from "../scripts/helpers/fitMapCircleWithContext.js";
export default {
	mixins: [
		formattingMixin,
		isMobMixin
	],

	props: {
		type: {
			type: String,
			default: null
		},

		items: {
			type: [Array, Object ],
			default: []
		},

		variables: {
			type: Object,
			default: {}
		},

		initParams: {
			type: Object,
			default: {}
		}
	},

	emits: [
		'drawing-area'
	],

	data() {
		return {
			loader: new Loader({
				apiKey: "AIzaSyBdN0KVu692vSBW1wd1QHP0TUSw-oPfcu4",
				version: "weekly",
				language: this.initParams.language || 'en'
			}),
			map: null,
			line: null,
			polygon: null,
			isAsideOpen: false,
			drawingMode: false,
			mouseUp: false,
			pathLine: null,
			handleDrawing: null,
			infoWindowActive: null,
			activeMarkerElement: null,
			markerCluster: null,
			activeClusterMarker: null,
			selectedMarkerCluster: [],
			clusterView: null,
			markers: [],
			watchedMarkers: [],
			isClusterDownload: false,
			asideVisible: false
		}
	},

	async mounted() {
		this.setArea(this.initParams.setArea)
		await this.initMap();
	},

	methods: {
		initMap() {
			this.asideVisible = false;

			return this.loader.load().then(async () => {
				const { Map } = await google.maps.importLibrary("maps");
				const { AdvancedMarkerElement } = await google.maps.importLibrary("marker");
				const map = new Map(document.getElementById("map"), {
					center: this.type ?
						this.initParams.center || {	lat: 34.7, lng: 33} :
						this.items.location.position,
					zoom: this.initParams.zoom || 7,
					zoomControl: !this.isSm,
					streetViewControl: false,
					mapTypeControl: false,
					fullscreenControl: false,
					clickableIcons: false,
					mapId: '952e5846ea5cd60b'
				});

				this.map = map;

				if (!this.type) {
					if (this.initParams.mode === 'radius' && Number(this.initParams.radius) > 0) {
						const circle = new google.maps.Circle({
							map,
							center: this.items?.location?.position,
							radius: Number(this.initParams.radius),
							fillColor: '#42948E',
							fillOpacity: 0.28,
							strokeColor: '#42948E',
							strokeOpacity: 0.9,
							strokeWeight: 2,
							clickable: false,
						});
						fitMapCircleWithContext(map, circle);
						return map;
					}

					const markerImg = document.createElement("img");
					markerImg.src = this.items?.map?.marker?.image?.src

					const advancedMarkerView = new AdvancedMarkerElement({
						map,
						position: this.items?.location?.position,
						content: markerImg
					});

					const infowindow = new google.maps.InfoWindow();
					infowindow.setContent(this.windowContent(this.items));

					infowindow.open({
						anchor: advancedMarkerView,
						map,
					});

					const element = advancedMarkerView.element;
					element.addEventListener('click', () => {
						infowindow.open({
							anchor: advancedMarkerView,
							map,
						});
					});
				} else {
					for (let i = 0; i < this.computedItems.length; i++) {
						const priceTag = document.createElement("div");
						priceTag.className = this.computedItems[i]?.location?.className;
						priceTag.textContent = `
							${this.computedItems[i]?.price?.current?.currency ?
								this.computedItems[i]?.price?.current?.currency : ''}
							${this.computedItems[i]?.price?.current?.value ?
								this.shortPrice(this.computedItems[i]?.price?.current?.value) : ''}`;
						priceTag.dataset.id = this.computedItems[i].id;
						priceTag.dataset.price = this.computedItems[i]?.price?.current?.value;

						const advancedMarkerView = new AdvancedMarkerElement({
							position: this.computedItems[i]?.location?.position,
							content: priceTag,
							collisionBehavior: 'REQUIRED_AND_HIDES_OPTIONAL'
						});
						advancedMarkerView.setMap(map);
						this.markers.push(advancedMarkerView);

						const element = advancedMarkerView.element;

						const infowindow = new google.maps.InfoWindow();
						infowindow.setContent(this.windowContent(this.computedItems[i]));

						const markerElement = element.querySelector(`.${this.computedItems[i]?.location?.className}`);

						if(this.watchedMarkers.length && this.watchedMarkers.find(element => element.querySelector(`.${this.computedItems[i]?.location?.className}`).getAttribute('data-id') === markerElement.getAttribute('data-id'))) {
							markerElement.classList.add('watched');
						}

						const onSelectMarker = () => {
							this.selectedMarkerCluster = [];

							if(this.activeClusterMarker) {
								this.activeClusterMarker = null;
								this.clusterView.clusters.forEach(cluster => {
									if(cluster.marker.element.querySelector('.cluster-tag')) {
										cluster.marker.element.querySelector('.cluster-tag').classList.remove('active');
									}
								})
							}
							if(this.activeMarkerElement) {
								this.markers.forEach(marker => {
									const markerElement = marker.element.querySelector(`.price-tag`)
									if(markerElement) {
										markerElement.classList.remove('active')
									}
								})
							}
							markerElement.classList.add('active');
							this.isAsideOpen = true;
							this.activeMarkerElement = markerElement;
							this.watchedMarkers.push(element);
							markerElement.classList.add('watched');

						}

						element.addEventListener('pointerdown', () => onSelectMarker());

						element.addEventListener('mouseover', () => {
							if(this.infoWindowActive) {
								this.infoWindowActive.close()
							}
							infowindow.open({
								anchor: advancedMarkerView,
								map,
							});
							this.infoWindowActive = infowindow;
						});

						element.addEventListener('mouseout', () => {
							if(this.infoWindowActive) {
								this.infoWindowActive.close()
							}
						});

						element.addEventListener('mouseenter', () => {
							advancedMarkerView.zIndex = 999999;

							this.isClusterDownload = true;
						});

						element.addEventListener('mouseleave', () => {
							advancedMarkerView.zIndex = 2;

							this.isClusterDownload = false;
						});
					}
				}

				const renderer = {
					render: ({ count, position, markers }) =>
						new AdvancedMarkerElement({
							content: this.clusterTag(count, this.clusterText, markers, position),
							position,
						})
				};

				if(this.markers.length) {
					this.clusterView = new MarkerClusterer({ map, markers: this.markers, onClusterClick: this.onClusterClickHandler, renderer});
				}

				if(this.pathLine) {
					const line = new google.maps.Polyline({
						path: this.pathLine,
						geodesic: true,
						strokeColor: "#2772DE",
						strokeOpacity: 1.0,
						strokeWeight: 2,
						clickable: false
					});

					line.setMap(this.map);

					this.line = line.getPath();

					const polygon = new google.maps.Polygon({
						path: this.pathLine,
						strokeColor: "#2772DE",
						strokeOpacity: 0,
						strokeWeight: 1,
						fillColor: "#2772DE",
						fillOpacity: 0.2,
					});

					polygon.setMap(this.map);

					this.polygon = polygon.getPath();
				}
			});
		},

		onClusterClickHandler(event, cluster, map) {
			this.asideVisible = true
			this.selectedMarkerCluster = cluster.markers.map(marker => ({'lat': marker.position.lat, 'lng': marker.position.lng}));
			this.isAsideOpen = true;
			map.setCenter(cluster.position);

			if(this.activeMarkerElement) {
				this.markers.forEach(marker => {
					const markerElement = marker.element.querySelector(`.price-tag`)
					if(markerElement) {
						markerElement.classList.remove('active')
					}
				})
			}

			if(this.activeClusterMarker) {
				this.activeClusterMarker = null;
				this.clusterView.clusters.forEach(cluster => {
					if(cluster.marker.element.querySelector('.cluster-tag')) {
						cluster.marker.element.querySelector('.cluster-tag').classList.remove('active');
					}
				})
			}

			this.activeClusterMarker = cluster.marker;
			cluster.marker.element.querySelector('.cluster-tag').classList.add('active')
		},

		clusterTag(count, clusterText, markers, position) {
			const clusterTag = document.createElement("div");
			clusterTag.className = 'cluster-tag';
			// if(this.activeClusterMarker && position.lat() == this.activeClusterMarker.position.lat && position.lng() == this.activeClusterMarker.position.lng) {
			// 	clusterTag.className = 'cluster-tag active';
			// } else {
			// 	clusterTag.className = 'cluster-tag';
			// }

			if (this.minValue(markers)) {
				clusterTag.innerHTML = `
				<div class="cluster-tag__number">
					${count}
				</div>
			`
			} else {
				clusterTag.innerHTML = `
				<div class="cluster-tag__number">
					${count}
				</div>
			`
			}

			return clusterTag;
		},

		windowContent(item) {
			if(this.type) {
				return `
					<div class="card-map" data-lat="${item?.location?.position?.lat}" data-lng="${item?.location?.position?.lng}" data-id="${item?.id}">
						<div class="status__item">
							<div class="status-label" style="background: ${item?.status[0]?.background}; color: ${item?.status[0]?.color};">
								<svg class="v-svg-icon svg-icon status-label-icon" style="display: ${item?.status[0]?.icon ? 'block' : 'none'}">
									<use href="/local/assets/dist/icons/sprite.svg#svg-icon-${item?.status[0]?.icon}"></use>
								</svg>
								${item?.status[0]?.text ? item?.status[0]?.text : ''}
							</div>
						</div>
						<img class="card-map__image" src="${item?.slides[0]?.src}"/>
						<div class="card-map__info">
							<div class="card-map__price">
								${item?.price?.current?.prefix ? item?.price?.current?.prefix : ''} ${item?.price?.current?.currency ? item?.price?.current?.currency : ''} ${item?.price?.current?.value ? this.formatInteger(item?.price?.current?.value) : ''} ${item?.price?.current?.postfix ? item?.price?.current?.postfix : ''}</div>
							<div class="card-map__title">${item?.title?.text ? item?.title?.text : ''} ${item?.title?.value ? item?.title?.value : ''} ${item?.title?.postfix ? item?.title?.postfix : ''}</div>
						</div>
					</div>`
			} else {
				return `
					<div class="card-map">
						<div class="status__item">
							<div class="status-label" style="background: ${item?.aside?.status[0]?.background}; color: ${item?.aside?.status[0]?.color};">
								<svg class="v-svg-icon svg-icon status-label-icon" style="display: ${item?.aside?.status[0]?.icon ? 'block' : 'none'}">
									<use href="/local/assets/dist/icons/sprite.svg#svg-icon-${item?.aside?.status[0]?.icon}"></use>
								</svg>
								${item?.aside?.status[0]?.text ? item?.aside?.status[0]?.text : ''}
							</div>
						</div>
						<img class="card-map__image" src="${item?.slider?.items[0]?.src}" alt=""/>
						<div class="card-map__info">
							<div class="card-map__price">${item?.aside?.price?.current?.prefix ? item?.aside?.price?.current?.prefix : ''} ${item?.aside?.price?.current?.currency ? item?.aside?.price?.current?.currency : ''} ${item?.aside?.price?.current?.value ? this.formatInteger(item?.aside?.price?.current?.value) : ''}  ${item?.aside?.price?.current?.postfix ? item?.aside?.price?.current?.postfix : ''}</div>
							<div class="card-map__title">${item?.title?.text} ${item?.title?.value ? item?.title?.value : ''} ${item?.title?.postfix ? item?.title?.postfix : ''}</div>
						</div>
					</div>`
			}
		},

		shortPrice(price) {
			if(!price) return
			const priceString = price.toString();
			if(priceString.length > 6) {
				return `${Number(priceString)/1000000}M`
			} else if(priceString.length > 3 && priceString.length <= 6) {
				return `${Number(priceString)/1000}K`
			} else {
				return price;
			}
		},

		minValue(markers) {
			let arr = markers.map(marker => marker.targetElement.querySelector('.price-tag').getAttribute('data-price')
			);

			return this.shortPrice(Math.min(...arr))
		},

		openAside() {
			this.isAsideOpen = !this.isAsideOpen
		},

		asideBack() {
			this.isAsideOpen = false;
			this.selectedMarkerCluster = [];
			this.activeClusterMarker = null;
			this.clusterView.clusters.forEach(cluster => {
				if(cluster.marker.element.querySelector('.cluster-tag')) {
					cluster.marker.element.querySelector('.cluster-tag').classList.remove('active');
				}
			})
		},

		drawing() {
			this.handleDrawing = !this.handleDrawing;
			let line;
			let polygon;

			if(this.handleDrawing) {
				this.map.setOptions({draggable: false});

				document.body.style.overflow = 'hidden'

				line = new google.maps.Polyline({
					geodesic: true,
					strokeColor: "#2772DE",
					strokeOpacity: 1.0,
					strokeWeight: 2,
					clickable: false
				});

				line.setMap(this.map);

				this.map.addListener('mousedown',  () => {
					this.drawingMode = true;
				});

				this.map.addListener('touchstart',  () => {
					this.drawingMode = true;
				});

				this.map.addListener('mouseup', () => {
					this.drawingMode = false;
					this.mouseUp = true;
				});

				this.map.addListener('touchend', () => {
					this.drawingMode = false;
					this.mouseUp = true;
				});

				const setPath = (event) => {
					if(this.drawingMode && !this.mouseUp) {
						const pathLine = line.getPath();
						pathLine.push(event.latLng);

					} else if(this.mouseUp) {
						google.maps.event.clearInstanceListeners(this.map);
						const pathLine = line.getPath();
						pathLine.push(pathLine.getAt(0));

						this.pathLine = pathLine;

						polygon = new google.maps.Polygon({
							path: pathLine,
							strokeColor: "#2772DE",
							strokeOpacity: 0,
							strokeWeight: 1,
							fillColor: "#2772DE",
							fillOpacity: 0.2,
						});

						polygon.setMap(this.map);

						const drawingArea = pathLine.getArray().map(item => {
							return {'lat': item.lat(), 'lng': item.lng()}
						})

						const requestData = {
							zoom: Math.round(this.map.zoom),
							center: {'lat': this.map.center.lat(), 'lng': this.map.center.lng()},
							locations: drawingArea
						}

						this.$emit('drawing-area', requestData);

						this.map.setOptions({draggable: true});

						document.body.style.overflow = 'auto'

						this.mouseUp = false;
					}
				}

				const throttledDrawing = throttle(setPath, 50)

				this.map.addListener('mousemove',  (event) => throttledDrawing(event))
				this.map.addListener('touchmove',  (event) => throttledDrawing(event))

			}

			if(this.pathLine && !this.handleDrawing) {

				this.polygon.clear();
				this.line.clear();
				this.pathLine.length = 0

				const requestData = {
					zoom: Math.round(this.map.zoom),
					center: {'lat': this.map.center.lat(), 'lng': this.map.center.lng()},
					locations: []
				}

				this.$emit('drawing-area', requestData);
			}

		},

		setArea(area) {
			if (area && area.length) {
				this.pathLine = area.map(location => {
					return {"lat": Number(location.lat), "lng": Number(location.lng)}
				} );
				this.handleDrawing = true;
			}
		},

		openModal() {
			controller.openModal({
				className: 'map-zoomed',
				component: {
					name: "v-modal-map",
					props: {
						dataSource: {
							zoom: this.initParams.zoom || 7,
							position: this.items?.location?.position || {lat: 34.7, lng: 33},
							mode: this.initParams.mode || 'point',
							radius: Number(this.initParams.radiusKm) || 0.5,
							readonly: true,
							marker: this.items?.map?.marker?.image?.src,
							language: this.initParams.language,
							items: this.items
						}
					},
				},

			});
		},

 	},

	computed: {
		clusterText() {
			switch (this.initParams.language) {
				case 'en':
					return 'from'
					break;
				case 'ru':
					return 'от'
					break;
				default:
					return 'from'
			}
		},

		filtredItemsLenght() {
			if (this.type) {
				const filtredArr = this.items.filter(item => item?.location?.position)
				if(filtredArr.length > 1) {
					return filtredArr.length
				} else {
					return 0
				}
			} else {
				return 0
			}
		},

		computedItems() {
			if (this.type) {
				if(this.selectedMarkerCluster.length) {
					return this.items.filter(item => this.selectedMarkerCluster.some(obj => JSON.stringify(obj) === JSON.stringify(item?.location?.position)))
				}

				if(this.activeMarkerElement) {
					return this.items.filter(item => item.id == this.activeMarkerElement.getAttribute('data-id'))
				}

				return this.items.filter(item => item?.location?.position)
			} else {
				return [];
			}
		}
	},

	watch: {
		// items: {
		// 	handler(newValue, oldValue) {
		// 		this.markers.forEach(item => item.setMap(null));
		// 		this.selectedMarkerCluster = [];
		// 		this.activeMarkerElement = null;
		// 		this.markers = [];
		// 		console.log('new items')
		// 		this.initMap();
		// 	},
		// 	deep: true
		// },
		items() {
			this.markers.forEach(item => item.setMap(null));
			this.selectedMarkerCluster = [];
			this.activeMarkerElement = null;
			this.markers = [];
			this.initMap();
		},

		isClusterDownload() {
			if(this.isClusterDownload) {
				this.clusterView.clusters.forEach(cluster => {
					const clusterElement = cluster.marker.element.querySelector('.cluster-tag');
					if(clusterElement) {
						clusterElement.addEventListener('mouseenter', () => {
							cluster.marker.zIndex = 999999;
						})
						clusterElement.addEventListener('mouseleave', () => {
							cluster.marker.zIndex = 2;
						});
					}

				} )
			}
		}
	}

}

</script>
